import "@szhsin/react-menu/dist/index.css";
import { observer } from "mobx-react";
import React from "react";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";
import { useReactMenuProps } from "../../../generic-components/common/useReactMenuProps";
import { useWhoAmI } from "../../../user/useWhoAmI";
import { useDevice } from "../../../utils/style/useDevice";
import { completeMenuItem } from "../MenuItems/completeMenuItem";
import { DeepFriedMenuItem } from "../../../generic-components/menu/DeepFriedMenuItem";
import { DepartmentTemplate } from "./DepartmentTemplate";
import {
  StyledProfileBtn,
  StyledProfileDropdown,
  StyledReactControlledMenu,
  StyledSimpleProfileDropdown,
} from "./SharedStyles";
import { useProfileDepartmentItems } from "./useProfileDepartmentItems";

export const ProfileMenu = withWSErrorContainer(
  observer(() => {
    const { isTabletOrMobile } = useDevice();
    const { confirmedHasProfileInConcern } = useWhoAmI();
    const { btnProps, controlledMenuProps } = useReactMenuProps();

    return (
      <>
        {isTabletOrMobile && (
          <StyledProfileBtn
            role="button"
            className="cvp-profile-btn"
            icon="pi pi-user"
            {...btnProps}
          />
        )}

        {!isTabletOrMobile && confirmedHasProfileInConcern && (
          <StyledProfileDropdown {...btnProps}>
            <DepartmentTemplate isTopBar />
            <i className="pi pi-user" />
          </StyledProfileDropdown>
        )}

        {!isTabletOrMobile && !confirmedHasProfileInConcern && (
          <StyledSimpleProfileDropdown {...btnProps}>
            <i className="pi pi-user" />
          </StyledSimpleProfileDropdown>
        )}

        {/* //React menu */}
        <StyledReactControlledMenu {...controlledMenuProps}>
          <ProfileDepReactMenuItems />
        </StyledReactControlledMenu>
      </>
    );
  })
);

interface ProfileDepReactMenuItemsProps {}

const ProfileDepReactMenuItems = withWSErrorContainer(
  observer((props: ProfileDepReactMenuItemsProps) => {
    const profileItems = useProfileDepartmentItems();
    const pItems = profileItems.map((items) => completeMenuItem(items));

    return (
      <>
        {pItems.map((pItem, index) => (
          <DeepFriedMenuItem key={`${index}_${pItem.label}`} pItem={pItem} />
        ))}
      </>
    );
  })
);
